export default __webpack_public_path__ + "static/media/logo1.65c67f08.png";